import Layout from '@/components/layout/index.vue'

export default {
  path: 'bidmanagementsup',
  name: 'Bidmanagementsup',
  meta: {},
  component: Layout,
  redirect: { name: 'Bidmanagementsup.Mybidding' },
  children: [
    {
      path: 'mybidding',
      name: 'Bidmanagementsup.Mybidding',
      meta: {},
      component: () => import(/* webpackChunkName: "bidmanagementsup" */ '@/views/supplier/bidmanagementsup/mybidding/index.ts')
    },
    {
      path: 'biddinghall/:id',
      name: 'Bidmanagementsup.Mybidding.Biddinghall',
      meta: { title: 'bidmanagementsup.biddinghall.biddinghall', dep: 'Bidmanagementsup.Mybidding' },
      component: () => import(/* webpackChunkName: "bidmanagementsup" */ '@/views/supplier/bidmanagementsup/mybidding/biddinghall.vue')
    },
    {
      path: 'biddingresult/:id',
      name: 'Bidmanagementsup.Mybidding.Biddingresult',
      meta: { title: 'bidmanagementsup.biddingresult.biddingresult', dep: 'Bidmanagementsup.Mybidding' },
      component: () => import(/* webpackChunkName: "bidmanagementsup" */ '@/views/supplier/bidmanagementsup/mybidding/biddingresult.vue')
    },
    {
      path: 'biddingsignup',
      name: 'Bidmanagementsup.Biddingsignup',
      meta: {},
      component: () => import(/* webpackChunkName: "bidmanagementsup" */ '@/views/supplier/bidmanagementsup/biddingsignup/index.ts')
    },
    {
      path: 'biddingsignup/enroll/:id',
      name: 'Bidmanagementsup.Biddingsignup.Enroll',
      meta: { title: 'bidmanagementsup.enroll.enroll', dep: 'Bidmanagementsup.Biddingsignup' },
      component: () => import(/* webpackChunkName: "bidmanagementsup" */ '@/views/supplier/bidmanagementsup/biddingsignup/enroll.vue')
    }
  ]
}
